import React from "react";
// import "./FeatureListing.css";
import { useNavigate } from "react-router";
import useFeatureListing from "../../customHooks/FeatureListing/useFeatureListing";
import CreateFeatureModal from "../CreateFeatureModal/CreateFeatureModal";
import { MdEdit } from "react-icons/md";
import usePermission from "../../utils/usePermission";
import { CiSearch } from "react-icons/ci";
import FullPageLoading from "../../components/FullPageLoading/FullPageLoading";
import UnAuthorized from "../UnAuthorized/UnAuthorized";
import { GiSettingsKnobs } from "react-icons/gi";
import FeatureConfigurationModal from "../FeatureConfigurationModal/FeatureConfigurationModal";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { format, parseISO, subMinutes } from "date-fns";
import Pagination from "react-js-pagination";
import { FaEye } from "react-icons/fa";

const FeatureListing = () => {
  const {
    handlePageClick,
    handlePageSizeChange,
    handleSearch,
    features,
    totalCount,
    searchTerm,
    featuresPerPage,
    currentPage,
    openCreateModal,
    setOpenCreateModal,
    selectedFeature,
    setSelectedFeature,
    fetchFeatures,
    loader,
    openConfiguration,
    setOpenConfiguration,
    featureCategories,
    activeIndex,
    toggleAccordion,
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    featureCategoryId,
    setFeatureCategoryId,
    dynamicHeaders,
    getHeadersForCategory,
    uniqueCategories,
  } = useFeatureListing();
  const navigate = useNavigate();
  const canRead = usePermission("FEATURE_READ");
  const canWrite = usePermission("FEATURE_CREATE");
  const canUpdate = usePermission("FEATURE_UPDATE");

  return (
    <div>
      {canRead ? (
        <>
          <div className="container">
            <div className="mainHeader">
              <h1 className="font-semibold text-lg">Feature Configurations</h1>
              <div className="gap-4 flex">
                {/* <button
                  className="add-plan-button"
                  onClick={() => {
                    navigate("/feature/configuration");
                  }}
                >
                  Feature Configuration
                </button> */}
                {canWrite && (
                  <button
                    className="add-plan-button"
                    onClick={() => {
                      setOpenCreateModal(true);
                    }}
                  >
                    + Add New Features
                  </button>
                )}
              </div>
            </div>
            <div className="mainHeader">
              <div className="flex gap-4">
                <div className="form-group">
                  <label htmlFor="featureCategoryId">Search</label>
                  <div className="search-container">
                    <input
                      type="text"
                      placeholder="Search..."
                      className="search-input"
                      value={searchTerm}
                      onChange={handleSearch}
                    />

                    <CiSearch className="search-icon" />
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="featureCategoryId">Category</label>
                  <select
                    id="featureCategoryId"
                    name="featureCategoryId"
                    value={featureCategoryId}
                    onChange={(e) => setFeatureCategoryId(e.target.value)}
                    // disabled={selectedFeature}
                  >
                    {featureCategories.map((category) => {
                      return (
                        <option value={category.sName}>{category.sName}</option>
                      );
                    })}
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="startDate">Start Date</label>
                  <input
                    type="datetime-local"
                    name="startDate"
                    id="startDate"
                    value={startDate ?? ""}
                    // onBlur={handleBlur}
                    onChange={(e) => setStartDate(e.target.value)}
                    placeholder="Enter Feature Name"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="endDate">End Date</label>
                  <input
                    type="datetime-local"
                    name="endDate"
                    id="endDate"
                    value={endDate ?? ""}
                    onChange={(e) => setEndDate(e.target.value)}
                    placeholder="Enter Feature Name"
                  />
                </div>
              </div>
              {/* <div className="items-per-page-container">
                      <select
                        id="itemsPerPage"
                        value={featuresPerPage}
                        onChange={handlePageSizeChange}
                        className="items-per-page-dropdown"
                      >
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option val40pxue={50}>50</option>
                      </select>
                    </div> */}
            </div>
            {!loader ? (
              <>
                <div className="mainContainer">
                  <div className="table-container">
                    <table className="data-table">
                      <thead>
                        <tr>
                          <th rowSpan={2}>Configuration Name</th>
                          <th
                            colSpan={dynamicHeaders.length}
                            className="text-center"
                          >
                            Configuration Parameters
                          </th>
                          <th rowSpan={2}>Configuration Description</th>
                          {/* <th rowSpan={2}>Product Count</th>
                          <th rowSpan={2}>Try On Count</th>
                          <th rowSpan={2}>Analytics Type</th>
                          <th rowSpan={2}>Comparison Types</th> */}
                          <th rowSpan={2}>Configuration Category</th>
                          <th rowSpan={2}>Created Date</th>
                          <th rowSpan={2}>Actions</th>
                        </tr>
                        {/* Second Row - Dynamic Categories (Sub-Header) */}
                        <tr>
                          {dynamicHeaders.map((category, i) => (
                            <th
                              key={i}
                              colSpan={getHeadersForCategory(category).length}
                            >
                              {category}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {features.length > 0 ? (
                          <>
                            {features?.map((row, index) => {
                              // const date = format(
                              //   parseISO(row.createdAt),
                              //   "dd/MM/yyyy 'at' HH:mm"
                              // );
                              const headersForRow = getHeadersForCategory(
                                row.featureCategoryName
                              );

                              const utcExpiry = subMinutes(
                                parseISO(row.createdAt),
                                330
                              );
                              const date = format(utcExpiry, "MMMM d, yyyy");

                              return (
                                <>
                                  <tr key={index}>
                                    <td>{row.title}</td>
                                    {dynamicHeaders.map((header, i) => {
                                      let value;
                                      if (row.featureCategoryName === "Core") {
                                        value =
                                          row.featureConfigs.find(
                                            (f) => f.sFieldName === header
                                          )?.sValue || "-";
                                      } else if (
                                        row.featureCategoryName === "Compare"
                                      ) {
                                        value = row.featureConfigs.find(
                                          (f) => f.sValue === header
                                        ) ? (
                                          <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="green"
                                            strokeWidth="3"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          >
                                            <path d="M20 6L9 17l-5-5" />
                                          </svg>
                                        ) : (
                                          <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="red"
                                            strokeWidth="3"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          >
                                            <path d="M18 6L6 18M6 6l12 12" />
                                          </svg>
                                        );
                                      } else if (
                                        row.featureCategoryName === "BodyType"
                                      ) {
                                        value = row.featureConfigs.find(
                                          (f) => f.sValue === header
                                        ) ? (
                                          <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="green"
                                            strokeWidth="3"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          >
                                            <path d="M20 6L9 17l-5-5" />
                                          </svg>
                                        ) : (
                                          <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="red"
                                            strokeWidth="3"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          >
                                            <path d="M18 6L6 18M6 6l12 12" />
                                          </svg>
                                        );
                                      } else if (
                                        row.featureCategoryName === "Analytics"
                                      ) {
                                        value = row.featureConfigs.find(
                                          (f) => f.sValue === header
                                        ) ? (
                                          <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="green"
                                            strokeWidth="3"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          >
                                            <path d="M20 6L9 17l-5-5" />
                                          </svg>
                                        ) : (
                                          <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="red"
                                            strokeWidth="3"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          >
                                            <path d="M18 6L6 18M6 6l12 12" />
                                          </svg>
                                        );
                                      } else if (
                                        row.featureCategoryName === "Set-up"
                                      ) {
                                        value = row.featureConfigs.find(
                                          (f) => f.sValue === header
                                        ) ? (
                                          <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="green"
                                            strokeWidth="3"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          >
                                            <path d="M20 6L9 17l-5-5" />
                                          </svg>
                                        ) : (
                                          <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="red"
                                            strokeWidth="3"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          >
                                            <path d="M18 6L6 18M6 6l12 12" />
                                          </svg>
                                        );
                                      } else if (
                                        row.featureCategoryName === "Support"
                                      ) {
                                        value = row.featureConfigs.find(
                                          (f) => f.sValue === header
                                        ) ? (
                                          <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="green"
                                            strokeWidth="3"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          >
                                            <path d="M20 6L9 17l-5-5" />
                                          </svg>
                                        ) : (
                                          <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="red"
                                            strokeWidth="3"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          >
                                            <path d="M18 6L6 18M6 6l12 12" />
                                          </svg>
                                        );
                                      }

                                      return (
                                        <td key={i}>
                                          {value === "-1" ? "Unlimited" : value}
                                        </td>
                                      );
                                    })}
                                    <td>{row.description}</td>
                                    <td>{row.featureCategoryName}</td>
                                    {/* <td>{productCount}</td>
                                  <td>{tryOnCount}</td>
                                  <td>{analyticsType}</td>
                                  <td>{comparisonTypes}</td> */}
                                    <td>{date}</td>
                                    <td className="actionBtns flex gap-2 h-full">
                                      {canUpdate && (
                                        <button
                                          className="editButtom"
                                          onClick={() => {
                                            setSelectedFeature(row);
                                            setOpenCreateModal(true);
                                          }}
                                        >
                                          <MdEdit />
                                        </button>
                                      )}

                                      <button
                                        className="editButtom"
                                        style={{ background: "" }}
                                        onClick={() => {
                                          setSelectedFeature(row);
                                          setOpenCreateModal(true);
                                        }}
                                      >
                                        <FaEye />
                                      </button>
                                    </td>
                                    {/* <td
                                  className={`toggle-indicator ${
                                    activeIndex === index ? "active" : ""
                                  }`}
                                  onClick={() => toggleAccordion(index)}
                                >
                                  {activeIndex === index ? (
                                    <IoIosArrowUp
                                      size={20}
                                      className="font-bold"
                                    />
                                  ) : (
                                    <IoIosArrowDown
                                      size={20}
                                      className="font-bold"
                                    />
                                  )}
                                </td> */}
                                  </tr>
                                  <tr
                                    className="accordion-content"
                                    style={{
                                      display:
                                        activeIndex === index
                                          ? "table-row"
                                          : "none",
                                    }}
                                  >
                                    <td colSpan="5">
                                      <table className="nested-table">
                                        <thead>
                                          <tr>
                                            <th>Feature Configuration</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            <td>
                                              {row?.featureConfigs.length
                                                ? row?.featureConfigs
                                                    ?.map(
                                                      (feature) =>
                                                        `${feature?.sFieldName}: ${feature?.sValue}`
                                                    )
                                                    .join(" | ")
                                                : "No configuration found"}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </td>
                                  </tr>
                                </>
                              );
                            })}
                          </>
                        ) : (
                          <>
                            <tr colSpan="6">
                              <td
                                colSpan="6"
                                className="text-center text-gray-600"
                              >
                                No Features Found
                              </td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                {totalCount > featuresPerPage && (
                  <div className="mt-6 flex justify-between items-center">
                    <span className="text-gray-600">
                      Showing {(currentPage - 1) * featuresPerPage + 1} to{" "}
                      {Math.min(currentPage * featuresPerPage, totalCount)} of{" "}
                      {totalCount} entries
                    </span>

                    <Pagination
                      activePage={currentPage}
                      itemsCountPerPage={featuresPerPage}
                      totalItemsCount={totalCount}
                      pageRangeDisplayed={5}
                      onChange={handlePageClick}
                      nextPageText={">"}
                      prevPageText={"<"}
                      firstPageText={"<<"}
                      lastPageText={">>"}
                      itemClass="page-item"
                      linkClass="page-link"
                    />
                  </div>
                )}
              </>
            ) : (
              <>
                <FullPageLoading />
              </>
            )}
          </div>

          <CreateFeatureModal
            show={openCreateModal}
            onHide={() => {
              setOpenCreateModal();
              setSelectedFeature(null);
            }}
            id={selectedFeature ? selectedFeature.featureId : null}
            selectedFeature={selectedFeature}
            fetchFeatures={fetchFeatures}
            featureCategories={featureCategories}
          />

          <FeatureConfigurationModal
            show={openConfiguration}
            onHide={() => {
              setOpenConfiguration(false);
              setSelectedFeature(null);
            }}
            id={selectedFeature ? selectedFeature.featureId : null}
            selectedFeature={selectedFeature}
            fetchFeatures={fetchFeatures}
            featureCategories={featureCategories}
            featureData={featureCategories.find(
              (id) =>
                id.iFeatureCategoryId === selectedFeature?.featureCategoryId
            )}
          />
        </>
      ) : (
        <UnAuthorized />
      )}
    </div>
  );
};

export default FeatureListing;
